import React from 'react';

// Import required components
import { Event, Heading } from '../../../components';
import { events } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Events = () => { 

  return (
    <section className='events'>

      {/* Section heading */}
      <Heading title={'Events We Cater'} subTitle={'Discover Our Catering Services'} />

      <Swiper

        modules={[Autoplay]} // Enable Autoplay feature
        spaceBetween={10} // Space between slides
        loop={true} // Enables Infinite Loop
        autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-scroll every 4 seconds

        // Responsive Breakpoints for Different Screen Sizes
        breakpoints={{
          450: { slidesPerView: 1 }, // 1 slide for small screens
          768: { slidesPerView: 2 }, // 2 slides for tablets
          1025: { slidesPerView: 3 }, // 3 slides for larger screens
        }}

      >
        
        {/* Map over the events array to render each event */}
        {events.map((event) => { 
          return (
            <SwiperSlide key={event.id}>

              {/* Render individual Event component */}
              <Event event={event} />

            </SwiperSlide>
          );
        })}
      </Swiper>

    </section>
  )
}

export default Events;